import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoMdAdd } from "react-icons/io";

const PmVendorMaster = () => {
  const gridApi = useRef(null);
  const gridColumnApi = useRef(null);
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [overlyBlock, setOverlyBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");
  const [rowData, setRowData] = useState([]);
  const [isSliderOpen, setSliderOpen] = useState(false);
  const [sliderType, setSliderType] = useState(null);
  const [sliderCl, setSliderCl] = useState("");
  const [sliderTitle, setSliderTitle] = useState("");
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  
  const [editFormData, setEditFormData] = useState({
    vendor_id: "",
    vendor_name: "",
    location: ""
  });

  const columnWithDefs = [
    {
      headerName: "",
      field: "actions",
      sortable: false,
      filter: false,
      width: "90px",
      cellClass: "custom-cell", 
      cellRendererFramework: (params) => (
        <div style={{
          height: "36px", 
          padding: 0, 
          display: "flex", 
          justifyContent: "center", 
          alignItems: "center"
        }}>
          <button
            title="Delete"
            style={{
              height: "30px",
              width: "60px",
              backgroundColor: "transparent",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => handleDelete(params.data)}
          >
            <RiDeleteBin5Line style={{ color: "red", fontSize: "20px" }} />
          </button>
        </div>
      ),
    },
    {
      headerName: "Vendor ID",
      field: "vendor_id",
      sortable: true,
      resizable: true,
      width: 120,
    },
    {
      headerName: "Vendor Name",
      field: "vendor_name",
      sortable: true,
      resizable: true,
      width: 200,
    },
    {
      headerName: "Location",
      field: "location",
      sortable: true,
      resizable: true,
      width: 150,
    },
    {
      headerName: "Inserted Date",
      field: "inserted_date",
      sortable: true,
      resizable: true,
      width: 150,
      hide: true,
      valueFormatter: (params) => {
        if (params.value) {
          return new Date(params.value).toLocaleDateString();
        }
        return '';
      }
    },
    {
      headerName: "Updated Date",
      field: "updated_date",
      sortable: true,
      resizable: true,
      width: 150,
      hide: true,
      valueFormatter: (params) => {
        if (params.value) {
          return new Date(params.value).toLocaleDateString();
        }
        return '';
      }
    }
  ];

  const resetFormData = () => {
    setEditFormData({ 
      vendor_id: "",
      vendor_name: "",
      location: ""
    });
  };

  // Hide Overlay and Slider
  const hideOverlySlideBlock = () => {
    setOverlyBlock("show-n");
    setLoadshow("show-n");
    setSliderOpen(false);
    resetFormData();
  };

  const onClickAddNewPmVendor = () => {
    resetFormData();
    setSliderOpen(true);
    setSliderType(1);
    setSliderCl("slider-25");
    setSliderTitle("Add New PM Vendor");
    setOverlyBlock("show-m");
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setShowDeletePopup(true);
    setOverlayBlock("show-m");
  };

  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);

  // Status Panel Configuration
  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  };

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    minWidth: 100,
  };

  const getPmVendorData = async () => {
    try {
      setLoadshow("show-m");
      setOverlayBlock("show-m");
      
      const response = await redirectURL.post("masters/getPmVendorData", {});
      
      if (response.status === 200) {
        if (response.data.data && response.data.data.length > 0) {
          setRowData(response.data.data);
          setTimeout(() => autoSizeAllColumns(), 100);
        } else {
          setBasicTitle("No PM Vendor data found");
          setBasicType("info");
          setShow(true);
        }
      }
    } catch (error) {
      console.error("Error fetching PM Vendor data:", error);
      setBasicTitle("Failed to fetch PM Vendor data");
      setBasicType("error");
      setShow(true);
    } finally {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
    }
  };

  const autoSizeAllColumns = () => {
    if (gridColumnApi.current) {
      const allColumns = gridColumnApi.current.getAllColumns();
      if (allColumns?.length) {
        const allColumnIds = allColumns.map((col) => col.getColId());
        gridColumnApi.current.autoSizeColumns(allColumnIds, false);
      }
    }
  };

  const onGridReady = (params) => {
    gridApi.current = params.api;
    gridColumnApi.current = params.columnApi;
    setTimeout(() => autoSizeAllColumns(), 100);
  };

  const closeAlert = () => {
    setShow(false);
    setLoadshow("show-n");
    setOverlayBlock("show-n");
    setOverlyBlock("show-n");
    setShowDeletePopup(false);
    setSliderOpen(false);
    resetFormData();
  };

  const onClickingSliderCloseIcon = () => {
    setOverlyBlock("show-n");
    setSliderOpen(false);
    resetFormData();
  };

  const handleInputChange = (field, value) => {
    setEditFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleAddPmVendor = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    
    const params = {
      vendor_id: editFormData.vendor_id,
      vendor_name: editFormData.vendor_name,
      location: editFormData.location
    };

    const mandatoryFields = ['vendor_id', 'vendor_name',"location"];
    const validationErrors = mandatoryFields.filter(
      (key) => !params[key] || params[key].toString().trim() === ""
    );

    if (validationErrors.length > 0) {
      setShow(true);
      setBasicType("info");
      setBasicTitle(`Please fill in all mandatory fields: ${mandatoryFields.join(", ")}`);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }

    // Validate Vendor ID format (alphanumeric)
    const vendorIdRegex = /^[A-Za-z0-9]+$/;
    if (!vendorIdRegex.test(params.vendor_id)) {
      setShow(true);
      setBasicType("info");
      setBasicTitle("Vendor ID should contain only letters and numbers");
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      return;
    }

    try {
      const response = await redirectURL.post("masters/addPmVendor", params);
      
      if (response.status === 200 && response.data.status === "success") {
        await getPmVendorData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("success");
        setBasicTitle("PM Vendor Added Successfully");
        setSliderOpen(false);
        setOverlyBlock("show-n");
        resetFormData();
        
        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "New PM Vendor Added",
          status: "Success",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle(response.data.message || "Failed to add PM Vendor");
        
        // User Action Triggering
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "New PM Vendor Added",
          status: "Failure",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      }
    } catch (error) {
      const message = error.response?.data?.message || "An error occurred";
      setShow(true);
      setBasicType("info");
      setBasicTitle(message);
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "New PM Vendor Added",
        status: "Failure",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }
  };

  const onClickingPopupDeleteBtn = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    
    try {
      const response = await redirectURL.post("masters/deletePmVendor", {
        id: selectedRow._id
      });
      
      if (response.data.status === "success") {
        await getPmVendorData();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShowDeletePopup(false);
        setShow(true);
        setBasicType("success");
        setBasicTitle("PM Vendor Deleted Successfully");
        
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "PM Vendor Deleted",
          status: "Success",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      } else {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setShow(true);
        setBasicType("info");
        setBasicTitle("Failed to delete PM Vendor");
        
        const userData = {
          email: localStorage.getItem("email"),
          user_code: localStorage.getItem("user_code"),
          action: "PM Vendor Deleted",
          status: "Failure",
          path: window.location.pathname
        };
        triggerUserAction(userData);
      }
    } catch (error) {
      setLoadshow("show-n");
      setOverlayBlock("show-n");
      setShow(true);
      setBasicType("info");
      setBasicTitle("Failed to delete PM Vendor");
      
      const userData = {
        email: localStorage.getItem("email"),
        user_code: localStorage.getItem("user_code"),
        action: "PM Vendor Deleted",
        status: "Failure",
        path: window.location.pathname
      };
      triggerUserAction(userData);
    }
  };

  const onClickDeletePopupCancelBtn = () => {
    setOverlayBlock("show-n");
    setShowDeletePopup(false);
  };

  const triggerUserAction = (trigerdata) => {
    redirectURL.post('inventory/triggerUserAction', trigerdata);
  };

  useEffect(() => {
    getPmVendorData();
  }, []);

  return (
    <>
      <div className="container-fluid mt-3">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={closeAlert}
            style={{ fontSize: "9px" }}
          />
        </div>

        <div className="row" style={{ fontSize: "1rem", fontWeight: "bold", fontFamily: "Arial, sans-serif" }}>
          <div className="col-sm-12">
            <h1 className="col-sm-12" style={{ color: "#B9366D", fontSize: "18px", fontWeight: "bold", fontFamily: "sans-serif" }}>
              PM Vendor Master
            </h1>
          </div>
          
          <div className="col-sm-12 mb-4" style={{ display: "flex", justifyContent: "flex-end" }}>
            <button 
              onClick={onClickAddNewPmVendor}
              style={{
                ...addButtonStyle,
                backgroundColor: "#93385D",
                color: "#fff",
                border: "2px solid #93385D",
              }}
            >
              <IoMdAdd style={{ color: "#fff", fontSize: "18px" }} />
              {" Add New"}
            </button>
          </div>

          {/* Data Grid */}
          <div className="col-sm-12 p-0 pl-2 mt-6">
            <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
              <AgGridReact
                rowData={rowData}
                columnDefs={columnWithDefs}
                defaultColDef={defaultColDef}
                domLayout="normal"
                sideBar={sideBar}
                statusBar={statusPanel}
                pagination={true}
                paginationPageSize={100}
                enableRangeSelection={true}
                gridOptions={{ suppressHorizontalScroll: false }}
                onGridReady={onGridReady}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Slider for Add */}
      <div className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`} style={{ width: "25%" }}>
        <div className="slider-header-container d-flex justify-content-between">
          <p className="m-0p">{sliderTitle}</p>
          <p className="m-0p" style={{ cursor: "pointer" }} onClick={onClickingSliderCloseIcon}>
            X&nbsp;&nbsp;&nbsp;
          </p>
        </div>

        {sliderType === 1 && (
          <div style={{ 
            display: "flex", 
            flexDirection: "column", 
            height: "100%", 
            overflow: "hidden" 
          }}>
            <form style={{ 
              flexGrow: 1, 
              overflowY: "auto", 
              padding: "20px",
              height: "100%"
            }}>
              <div style={{ paddingBottom: "20px" }}>
                {/* Vendor ID */}
                <div className="form-group">
                  <label htmlFor="vendor_id" style={labelStyle}>
                    Vendor ID <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="vendor_id"
                    value={editFormData.vendor_id}
                    onChange={(e) => handleInputChange('vendor_id', e.target.value.toUpperCase())}
                    placeholder="Enter Vendor ID (e.g., PM001)"
                    style={inputStyle}
                    required
                    autoComplete="off"
                    maxLength={20}
                  />
                </div>

                {/* Vendor Name */}
                <div className="form-group">
                  <label htmlFor="vendor_name" style={labelStyle}>
                    Vendor Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="vendor_name"
                    value={editFormData.vendor_name}
                    onChange={(e) => handleInputChange('vendor_name', e.target.value)}
                    placeholder="Enter Vendor Name"
                    style={inputStyle}
                    required
                    autoComplete="off"
                    maxLength={100}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="location" style={labelStyle}>
                    Location <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="location"
                    value={editFormData.location}
                    onChange={(e) => handleInputChange('location', e.target.value)}
                    placeholder="Enter Location"
                    style={inputStyle}
                    required
                    autoComplete="off"
                    maxLength={100}
                  />
                </div>

                <div style={submitButtonContainerStyle}>
                  <button
                    type="button"
                    onClick={handleAddPmVendor}
                    style={submitButtonStyle}
                  >
                    ADD
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}
      </div>

      {/* Delete Confirmation Popup */}
      {showDeletePopup && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={deletePopupStyle}
        >
          <div className="inventory-delete-popup">
            <p style={deletePopupTextStyle}>
              {`Are you sure you want to delete ${selectedRow ? selectedRow.vendor_name : ""}?`}
            </p>
            <div className="d-flex justify-content-center align-items-center">
              <button className="btn btn-danger" onClick={onClickingPopupDeleteBtn}>
                Delete
              </button>
              <button className="btn btn-secondary" onClick={onClickDeletePopupCancelBtn}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Loader and Overlays */}
      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
      <div className={"overly-block " + overlyBlock} onClick={hideOverlySlideBlock}></div>
    </>
  );
};

// Styles
const addButtonStyle = {
  padding: "5px 20px",
  backgroundColor: "#93385D",
  color: "#fff",
  fontFamily: "sans-serif",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.8rem",
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  gap: "5px"
};

const labelStyle = {
  fontSize: "0.9rem",
  fontWeight: "bold",
  color: "#333",
  marginBottom: "5px",
  display: "block"
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "5px",
  border: "1px solid #ccc",
  fontSize: "0.9rem"
};

const submitButtonContainerStyle = {
  textAlign: "right",
  marginTop: "20px",
  paddingTop: "10px",
  borderTop: "1px solid #eee"
};

const submitButtonStyle = {
  backgroundColor: "#93385D",
  color: "#fff",
  padding: "10px 30px",
  border: "none",
  borderRadius: "5px",
  cursor: "pointer",
  fontSize: "0.9rem",
  fontWeight: "bold"
};

const deletePopupStyle = {
  position: "fixed",
  top: "40%",
  left: "40%",
  zIndex: "1003",
  backgroundColor: "rgba(255, 255, 255, 0.9)",
  padding: "20px",
  borderRadius: "10px",
};

const deletePopupTextStyle = {
  color: "grey",
  fontSize: "19px",
  textAlign: "center",
  fontWeight: "bold",
  marginBottom: "20px",
};

export default PmVendorMaster;